(() => {
  const init = () => {
    const journey = document.querySelector('[data-cj-journey]');
    if (!journey || journey.dataset.ready) return;
    journey.dataset.ready = 'true';
    const bar = journey.querySelector('[data-cj-sticky]');
    const purchase = document.getElementById('cj-mango-purchase');
    const form = document.getElementById('main-product-form-6760919826591');
    if (!form || !purchase) return;
    journey.querySelectorAll('[data-cj-return]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      purchase.scrollIntoView({block:'center',behavior:'instant'});
      const button = form.querySelector('button[type="submit"]');
      if (button) button.focus({preventScroll:true});
    }));
    if (!bar) return;
    const visible = element => {
      const r = element.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none';
    };
    let queued = false;
    const update = () => {
      queued = false;
      const r = form.getBoundingClientRect();
      const obstructed = [...document.querySelectorAll('.m6pn.toggle,dialog[open],[aria-modal="true"],#nav[aria-expanded="true"],#ads-agent-host,#PBarNextFrame')].some(el => {
        if (!visible(el)) return false;
        const box = el.getBoundingClientRect();
        return box.top < innerHeight && box.bottom > innerHeight-100;
      });
      const nativeButton = form.querySelector('button[type="submit"]');
      const menuOpen = document.documentElement.classList.contains('has-nav');
      const hide = innerWidth>1024 || r.bottom>0 || obstructed || menuOpen || !nativeButton || nativeButton.disabled || nativeButton.classList.contains('disabled');
      if (bar.hidden !== hide) bar.hidden=hide;
    };
    const schedule = () => { if (!queued) { queued=true; requestAnimationFrame(update); } };
    const observer = new IntersectionObserver(schedule);
    observer.observe(form);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    const mutations = new MutationObserver(schedule);
    mutations.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','aria-hidden','aria-expanded','disabled']});
    update();
    document.addEventListener('shopify:section:unload',event=>{
      if (!event.target.contains(journey)) return;
      observer.disconnect(); mutations.disconnect();
      window.removeEventListener('scroll',schedule); window.removeEventListener('resize',schedule);
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
